import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  FormGroup,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";

@Component({
  selector: "ws-duration",
  templateUrl: "./ws-duration.component.html",
  styleUrls: ["./ws-duration.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => WsDurationComponent),
      multi: true,
    },
  ],
})
export class WsDurationComponent implements ControlValueAccessor, OnChanges {
  @Input() value: string | null = null;
  @Input() formControlName?: string;
  @Output() valueChange = new EventEmitter<number>();

  durationForm: FormGroup;

  onChange = (value: number) => {};
  onTouched = () => {};

  constructor(private fb: FormBuilder) {
    this.durationForm = this.fb.group({
      interval_days: [null],
      interval_hours: [null],
      interval_minutes: [null],
    });
    console.log(this.durationForm);
    this.durationForm.valueChanges.subscribe((val) => {
      const durationString = this.toLongMinutesDuration(val);
      this.onChange(durationString);
      this.valueChange.emit(durationString);
    });
  }

  onInputChange(event: Event, field: string): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;

    value = value.replace(/[^0-9]/g, '');
    if (input.value !== value) {
      input.value = value;
      this.durationForm.get(`interval_${field}`)?.setValue(value);
    }
  }

  onInputBlur(event: Event, field: string): void {
    const input = event.target as HTMLInputElement;
    let value = input.value;
    value = value.replace(/[^0-9]/g, '');
    
    if (value && isNaN(Number(value))) {
      value = '';
    }
    
    this.durationForm.get(`interval_${field}`)?.setValue(value);
    input.value = value;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["value"] && this.value) {
      this.parseDuration(this.value);
    }
  }

  writeValue(value: string): void {
    this.value = value;
    if (value) {
      this.parseDuration(value);
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  private parseDuration(value: string): void {
    let d = 0,
      h = 0,
      m = 0;
    if (/\d{2}:\d{2}:\d{2}/.test(value)) {
      const [dd, hh, mm] = value.split(":");
      d = +dd;
      h = +hh;
      m = +mm;
    } else {
      const dayMatch = value.match(/(\d+)d/);
      const hourMatch = value.match(/(\d+)h/);
      const minMatch = value.match(/(\d+)m/);
      d = dayMatch ? +dayMatch[1] : 0;
      h = hourMatch ? +hourMatch[1] : 0;
      m = minMatch ? +minMatch[1] : 0;
    }
    this.durationForm.setValue(
      {
        interval_days: d,
        interval_hours: h,
        interval_minutes: m,
      },
      { emitEvent: false }
    );
  }

  private toFormattedDuration({
    interval_days,
    interval_hours,
    interval_minutes,
  }: any): string {
    const days = interval_days || 0;
    const hours = interval_hours || 0;
    const minutes = interval_minutes || 0;

    let result = "";
    if (days) result += `${days}d`;
    if (hours) result += `${hours}h`;
    if (minutes) result += `${minutes}m`;

    // Return "0m" if all values are zero
    return result || "0m";
  }

  private toLongMinutesDuration({
    interval_days,
    interval_hours,
    interval_minutes,
  }: any): number {
    const days = Number(interval_days) || 0;
    const hours = Number(interval_hours) || 0;
    const minutes = Number(interval_minutes) || 0;

    const totalMinutes = days * 24 * 60 + hours * 60 + minutes;
    return totalMinutes;
  }
}
